






















































import { Component, Prop, Vue } from "vue-property-decorator";
import ReactivateUser from "../employee/useram/ReactivateUser.vue";

@Component({
  components: { ReactivateUser },
})
export default class LoginPage extends Vue {
  year: number;
  @Prop({ default: "" }) readonly versionSichern!: string;
  data() {
    return {
      year: 0,
      baseUrl: process.env.VUE_APP_BASE,
    };
  }
  created() {
    let d = new Date();
    this.year = d.getFullYear();
  }
}
